export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/83e791c702f67cc0242109b04d241be7.svg";